import keyBy from 'lodash/keyBy';

import { FeatureFlagResolved } from '@cast/types';

import { FlagResolver, FlagResolverList } from '../types';

const resolveFlag = ({
  flags,
  flagsResolved,
  matcher = 'AND',
}: {
  flags: FlagResolverList;
  flagsResolved: FeatureFlagResolved[];
  matcher?: 'AND' | 'OR';
}): boolean => {
  return flags[matcher === 'AND' ? 'every' : 'some']((configFlag) => {
    if (typeof configFlag === 'function') {
      return configFlag(flagsResolved);
    }

    const flagsByName = keyBy(flagsResolved, 'flagName');

    if (configFlag in flagsByName) {
      return flagsByName[configFlag]?.boolean;
    }

    return false;
  });
};

export const resolveActionFlags = (
  configFlags: FlagResolver,
  flagsResolved: FeatureFlagResolved[]
): boolean => {
  if (Array.isArray(configFlags)) {
    return resolveFlag({ flags: configFlags, flagsResolved });
  }

  return resolveFlag({
    flags: configFlags.flags,
    flagsResolved,
    matcher: configFlags.matcher,
  });
};
